import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppMutation } from '../use-app-mutation.hook';
import { useInvalidateQueries } from '../use-invalidate-queries.hook';
import { SPACE_INVALIDATION_KEYS } from './space-invalidation.const';

export const useDeleteDataRoom = () => {
  const { invalidateQuery } = useInvalidateQueries(...SPACE_INVALIDATION_KEYS);

  const { isPending, mutate: deleteDataRoom } = useAppMutation<unknown, unknown, { id: string }>(
    [QueryKey.DELETE_DATA_ROOM],
    {
      mutationFn: ({ id }) =>
        ApiService.delete({ endpoint: BackendRoute.DATA_ROOMS, routePath: [id] }),
      onSuccess: () => {
        invalidateQuery();
      },
    },
  );

  return { deleteDataRoom, isPending };
};
